import api, {apiTs} from '../../../services/api';

// export const getDashboard = () => api.get('/manager/dashboard');

export const DashboardHTTP = {
  get: () => api.get('/manager/dashboard'),
  getRanking: () => apiTs.get('/dashboard-admin'),
};
